import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { VERIFY_STAFF_MUTATION } from "../../../../../platform/graphql/mutations";
import ChangePassword from "../../../../../platform/components/auth/changePassword";


const UpdateStaffStatus = () => {
  const { token } = useParams();
  const [userData, setUserData] = React.useState(null)
  const [verifyStaffApply, { data, loading, error }] = useMutation(
    VERIFY_STAFF_MUTATION
  );
  const [approved, setApproved] = useState(false);
  useEffect(() => {
    if (token) {
      // Call the mutation with the token
      verifyStaffApply({ variables: { id: token } }).then((val) => {
        setApproved(true);
      });
    }
  }, [token, verifyStaffApply]);

  useEffect(() => {
    setUserData(data?.verifyStaffApply)
  }, [data])
  // Display loading, error, or success messages
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;
  if (userData) return (
    <div>
      <ChangePassword userData={userData} />
      {/* Additional UI elements as needed */}
    </div>
  );
};

export default UpdateStaffStatus;
